import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

/**
 * React functional component representing the dental details for the mod flex selection details modal.
 * @returns {React.Component} The rendered dental details component.
 */
const DentalDetails = ({ data }) => (
    <div style={{ whiteSpace: 'pre-line' }}>
        {
            data.combineBasicAndMajor ?
                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.coverage.combinedMaximumCombinedMax, { combinedMax: helpers.formatNumber(data.basicMajorCombinedMax) }) }
                </Text>
                :
                <React.Fragment>
                    {
                        data.includeMajor ?
                            <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.majorMax) } ${ i18n.t(tokens.labels.planDesign.majorMaximum) }` }</Text>
                            : null
                    }
                    {
                        data.includeBasic ?
                            <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.basicMax) } ${ i18n.t(tokens.labels.planDesign.basicMaximum) }` }</Text>
                            : null
                    }
                </React.Fragment>
        }

        {
            data.includeBasic ?
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.routineCareReimbursement, { routineCareReimbursement: data.basicReimbursement }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.endodonticsReimbursement, { endodonticsReimbursement: data.basicReimbursement }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.periodonticsReimbursement, { periodonticsReimbursement: data.basicReimbursement }) }
                    </Text>
                </React.Fragment>
                : null
        }

        {
            data.includeMajor ?
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.bridgeWorkReimbursement, { bridgeWorkReimbursement: data.majorReimbursement }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.crownsReimbursement, { crownsReimbursement: data.majorReimbursement }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.denturesReimbursement, { denturesReimbursement: data.majorReimbursement }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.dentureRepairReimbursement, { dentureRepairReimbursement: data.majorReimbursement }) }
                    </Text>
                </React.Fragment>
                : null
        }

        <Text small margin="5px 0px 0px 0px">
            { i18n.t(tokens.labels.coverage.unitsOfScaling, { unitsOfScaling: data.unitsOfScaling }) }
        </Text>

        <Text small margin="5px 0px 0px 0px">
            { i18n.t(tokens.labels.coverage.dentalRecall, { monthsToRecall: data.monthsToRecall }) }
        </Text>

        {
            data.hasDeductible &&
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.deductibleForSoloCoverage, { soloDeductibleAmount: helpers.formatNumber(data.soloDeductibleAmount) }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.deductibleForDuoCoverage, { duoDeductibleAmount: helpers.formatNumber(data.duoDeductibleAmount) }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.deductibleForFamilyCoverage, { familyDeductibleAmount: helpers.formatNumber(data.familyDeductibleAmount) }) }
                    </Text>
                </React.Fragment>
        }

        {
            data.includeOrthodontics &&
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.planDesign.orthodonticLifetimeMaximum, { orthodonticLifetimeMax: helpers.formatNumber(data.orthodonticLifetimeMax) }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.orthodonticReimbursement, { orthodonticReimbursement: data.orthodonticReimbursement }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.orthodonticsTermination, { orthodonticTerminationAge: data.orthodonticTerminationAge }) }
                    </Text>
                </React.Fragment>
        }

        <Text small margin="5px 0px 0px 0px">
            { i18n.t(tokens.labels.coverage.monthsSurvivorBenefit, { monthsSurvivorBenefit: data.monthsSurvivorBenefit }) }
        </Text>
        <Text small margin="5px 0px 0px 0px">
            { i18n.t(tokens.labels.coverage.monthWaitingPeriod, { eligibilityPeriod: data.eligibilityPeriod }) }
        </Text>
        <Text small margin="5px 0px 0px 0px">
            { i18n.t(tokens.labels.coverage.minimumHoursPerWeekRequired, { minHoursPerWeek: data.minHoursPerWeek }) }
        </Text>
        <Text small margin="5px 0px 0px 0px">
            { i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: data.terminationAge }) }
        </Text>
    </div>
);

export default DentalDetails;